export enum OngoingABTests {
    USP_LISTING_TILE = "rp-tile-usp",
    PROPERTY_FAQ = "rp_faq_property_page"
}
export enum OngoingABTests {
    USP_LISTING_TILE = "rp-tile-usp",
    PROPERTY_FAQ = "rp_faq_property_page"
}
